import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthApi } from '../hooks/use-auth-api';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuthApi();

  if (isLoading) {
    return <div className="loading">در حال بارگذاری...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;